import { Routes } from '@angular/router';

import { HomeComponent } from '../../home/home.component';
import { UserComponent } from '../../user/user.component';
import { TablesComponent } from '../../tables/tables.component';
import { TypographyComponent } from '../../typography/typography.component';
import { IconsComponent } from '../../icons/icons.component';
import { MapsComponent } from '../../maps/maps.component';
import { NotificationsComponent } from '../../notifications/notifications.component';
import { UpgradeComponent } from '../../upgrade/upgrade.component';
import { ProductsComponent } from '../../../app/products/products.component';
import { LoginComponent } from '../../../app/login/login.component';
import { ConsultationComponent } from '../../../app/consultation/consultation.component';
import { OrderConsultComponent } from '../../../app/order-consult/order-consult.component';
import { ReorderConsultComponent } from '../../../app/reorder-consult/reorder-consult.component';
import { WikiComponent } from '../../../app/wiki/wiki.component';
export const AdminLayoutRoutes: Routes = [
    // { path: 'dashboard',      component: HomeComponent },
    // { path: 'user',           component: UserComponent },
    // { path: 'table',          component: TablesComponent },
    // { path: 'typography',     component: TypographyComponent },
    // { path: 'icons',          component: IconsComponent },
    // { path: 'maps',           component: MapsComponent },
    // { path: 'notifications',  component: NotificationsComponent },
    // { path: 'upgrade',          component: UpgradeComponent },
    { path: 'products', component: ProductsComponent },
    // {path: 'login', component: LoginComponent}
    { path: 'consult', component: ConsultationComponent },
    { path: 'order', component: OrderConsultComponent },
    { path: 'reorder', component: ReorderConsultComponent },
    { path: 'wiki', component: WikiComponent }];
